/**
 * SALTT Pricing Display — Stick Packs PDP (display only)
 *
 * Shows three per-stick pricing lines:
 * - 1-3 bag purchase (regular one-time)
 * - 4+ bag purchase (bundle discount)
 * - 4+ bag subscription (subscription bundle discount)
 *
 * The actual discount code apply/remove logic lives in
 * saltt-discount-auto-apply.liquid so it works on every page.
 */
(function () {
	"use strict";

	function qs(sel, root) {
		return (root || document).querySelector(sel);
	}

	function init() {
		const container = qs("#SalttPricing");
		if (!container) return;

		const sticksPerBag = parseInt(container.dataset.sticksPerBag || "30", 10);
		const bundleDiscountPercent = parseInt(
			container.dataset.bundleDiscountPercent || "10",
			10,
		);
		const subBundleDiscountPercent = parseInt(
			container.dataset.subBundleDiscountPercent || "20",
			10,
		);
		const moneyFormat = container.dataset.moneyFormat || "${{amount}}";

		let currentVariantPrice = parseInt(
			container.dataset.variantPrice || "0",
			10,
		);
		const regularPriceEls = container.querySelectorAll(
			'[data-pricing="regular"]',
		);
		const bundlePriceEls = container.querySelectorAll(
			'[data-pricing="bundle"]',
		);
		const subBundlePriceEls = container.querySelectorAll(
			'[data-pricing="bundle-sub"]',
		);

		function formatMoney(cents) {
			const amount = (cents / 100).toFixed(2);
			const amountNoDecimals = Math.round(cents / 100).toString();
			const amountWithComma = amount.replace(".", ",");
			return moneyFormat
				.replace("{{amount_with_comma_separator}}", amountWithComma)
				.replace(
					"{{amount_no_decimals_with_comma_separator}}",
					amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
				)
				.replace("{{amount_no_decimals}}", amountNoDecimals)
				.replace("{{amount}}", amount);
		}

		function updatePricing() {
			const regularCentsPerStick = Math.floor(
				currentVariantPrice / sticksPerBag,
			);
			const bundleFactor = (100 - bundleDiscountPercent) / 100;
			const subBundleFactor = (100 - subBundleDiscountPercent) / 100;
			const bundleCentsPerStick = Math.floor(
				(currentVariantPrice * bundleFactor) / sticksPerBag,
			);
			const subBundleCentsPerStick = Math.floor(
				(currentVariantPrice * subBundleFactor) / sticksPerBag,
			);

			regularPriceEls.forEach(function (el) {
				el.textContent = formatMoney(regularCentsPerStick);
			});
			bundlePriceEls.forEach(function (el) {
				el.textContent = formatMoney(bundleCentsPerStick);
			});
			subBundlePriceEls.forEach(function (el) {
				el.textContent = formatMoney(subBundleCentsPerStick);
			});
		}

		/* ==================== VARIANT CHANGE ==================== */

		if (typeof theme !== "undefined" && theme.pubsub) {
			theme.pubsub.subscribe(
				theme.pubsub.PUB_SUB_EVENTS.variantChange,
				function (event) {
					const newVariant = event && event.data && event.data.variant;
					if (newVariant) {
						currentVariantPrice = newVariant.price;
						updatePricing();
					}
				},
			);
		}

		/* ==================== INIT ==================== */

		updatePricing();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
